var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showList)?[_c('ShipSopList')]:[_c('NoShipSop')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }